
import channelIO from "@/assets/js/channel-io";
import { Component, Vue } from "vue-property-decorator";
import { MstMemberVO } from "@/views/biz/join/vo/join.vo";
import axios from "axios";
import Constants from "@/constants";
import CommonUtils from "@/common-utils";
import { MstCountryVO } from "@/views/biz/country/vo/country.vo";

// 글로벌에서만 채팅 사용함
let channel;
if (CommonUtils.isSystemLocale("global") == true) {
  channel = new channelIO();
}
@Component
export default class MemberInfo extends Vue {
  member: MstMemberVO = {} as MstMemberVO;
  countries: Array<MstCountryVO> = [] as Array<MstCountryVO>;
  //비밀번호 동일한지 확인
  checkPassword = '';
  isMailing = false;
  oldCountryCd = '';
  save() {
    if (this.member) {
      if(this.member.oldPassword || this.member.newPassword || this.checkPassword) {
        if(CommonUtils.validatePassword(this.member.newPassword) == false) {
          // 비밀번호는 영어와 숫자 조합으로 8자 이상 16자 이하로 입력해야 합니다.
          return alert(this.$t('member-info.a0007').toString());
        }
        if(this.member.validatPreexistencePassword == 'Y'  &&!this.member.oldPassword) {
          //기존 비밀번호를 확인해주세요.
          return alert(this.$t('member-info.a0017').toString()); 
        }
        if(this.member.newPassword && this.member.newPassword != this.checkPassword) {
          // 비밀번호가 일치하지 않습니다.
          return alert(this.$t('member-info.a0005').toString());
        }        
      }
      if(!this.member.repCountryCd) {
        // 국가를 선택해주세요.
        return alert(this.$t('join.a0046').toString());
      }      
      // 저장하시겠습니까?
      if (confirm(this.$t("common.c0002").toString()) == false) {
        return;
      }
      this.member.mailingType = this.isMailing ? "01" : "02";
      //TODO 수정 후 세션 업데이트 해줘야 함
      axios.put("/mypage/profile/member-info", this.member).then(() => {
        // 저장되었습니다.
        alert(this.$t("member-info.a0024"));
        //저장 후 로컬스토리지 삭제 및 다음 페이지 이동
        this.endMemberInfo();
      });
    }
  }

  //저장 후 로컬스토리지 삭제 및 다음 페이지 이동
  // 1. 로컬스토리지 삭제
  // 2. 세션아이디 (아이폰 앱 내 저장된..) 동기화
  // 3. 페이지 전환
  endMemberInfo() {
    //국가 변경 시 로그아웃
    if(this.oldCountryCd != this.member.repCountryCd){
      axios.get("/logout").then((r) => {
        this.$session.destroy();
        this.$store.dispatch("updateCartCount"); //장바구니 업데이트

        sessionStorage.removeItem(Constants.SESSION_LOGIN);
        this.$store.commit("touchKeepAlive");
        this.$router.push({ name: "Main" });
      });      
    }else {
      const orderPaymentCd = CommonUtils.getLocalStorageObject(Constants.ORDER_PAYMENT_CD);
      if (orderPaymentCd) {
        // 로컬스토리지 지역변수 저장 후 로컬스토리지 삭제
        CommonUtils.removeLocalStorageObject(Constants.ORDER_PAYMENT_CD);
        this.$router.push({ name: "OrderPayment", params: { orderCd: orderPaymentCd } });
      } else {
        this.$router.push({ name: "Mypage" });
      }
    }
  }

  realNameAuth(): void {
    // PC면 새창
    if(this.$isMobile == false) {
      window.open(`${CommonUtils.createStaticUrl(this, 'RealNameForm' )}?nextRouteName=MemberInfo`, "_blank", "width=762, height=800")
      return;
    } 

    this.$router.push({ name: "RealNameForm", params: { nextRouteName: "MemberInfo" } });
  }

  created() {
    if (window.opener) {
      window.opener.location.href = CommonUtils.createStaticUrl(this, 'MemberInfo');
      window.close();
      return;
    }

    axios
      .get("/mypage/profile/validation")
      .then((r) => {
        if (r.data) {
          this.member = r.data.member;
          this.oldCountryCd = this.member.repCountryCd;
          this.countries = r.data.countries;
          this.isMailing = this.member.mailingType == "01";
        }
      })
      .catch(() => {
        this.$router.push({ name: "MemberInfoConfirm" });
      });
  }
}
